import yup from "../../../../../../validation/yup";
import {
    generateInvalidMessage,
    generateMinInvalidMessage,
    generateRequiredMessage,
    USER_EMAIL
} from "../../../../../../validation/user";
import {MIN_NAME_LENGTH} from "../../../../../../validation/lengthConstants";
import {nameRegExp} from "../../../../../auth/pages/Partners/SignUp/form";

export const initialValues = {
    email: "",
    firstName: "",
    lastName: "",
    roleId: null
}

export const validationSchema = yup.object().shape({
    email: USER_EMAIL.required(),
    firstName: yup
        .string()
        .min(MIN_NAME_LENGTH, generateMinInvalidMessage("First name", MIN_NAME_LENGTH))
        .matches(nameRegExp, generateInvalidMessage("first name"))
        .trim()
        .required(generateRequiredMessage("First name")),
    lastName: yup
        .string()
        .min(MIN_NAME_LENGTH, generateMinInvalidMessage("Last name", MIN_NAME_LENGTH))
        .matches(nameRegExp, generateInvalidMessage("last name"))
        .trim()
        .required(generateRequiredMessage("Last name")),
    roleId: yup
        .number()
        .nullable()
        .required(generateRequiredMessage("Role")),
});